import { render, staticRenderFns } from "./EnterOtp.vue?vue&type=template&id=6a9d7b3e&"
import script from "./EnterOtp.vue?vue&type=script&lang=js&"
export * from "./EnterOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports